import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * CheckRestoreRecurrentOrders
 *
 * @private
 */
export const checkRestoreRecurrentOrders = createAsyncThunk<
  // Return type of the payload creator
  Record<string, number>,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/order/checkRestoreRecurrentOrders', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/checkRestoreRecurrentOrders', {
      category: 'rpc',
      type: 'rpc/order/checkRestoreRecurrentOrders',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on checkRestoreRecurrentOrders`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `checkRestoreRecurrentOrders call failed`,
      error,
    })
  }
})
